const deleteCacheEntryFromStorage = async (key: string): Promise<void> => {};

export default deleteCacheEntryFromStorage;
